// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AL-3","colBig":"styles_colBig__2oPE3","colSmall":"styles_colSmall__1MjZs","shopifyNameWrapper":"styles_shopifyNameWrapper__3p8dQ"};